import {
    changeBorderColor,
    changeBorderImpactColor,
    changeBorderImpactIntersectionColor
} from "../../data/tableFunc";
import { BorderErrorColor } from "../../data/table";
import {
    setPermissionFunc,
    setPermissionAddBoolFunc
} from "../components/PermissionFunc";
import { pageToTableMapFunc } from "../Common";
import { LOCAL_CONSTANT } from "../Const";

// 吹き出しスタイル
export const chatBubbleErrorSx = (userType: any, taskId: any, pageName: string, labelName: string, listDeficiencyComment:any) => {
    const disabledFlag = setPermissionFunc(userType, taskId, pageName, labelName);
    const pageToTableMap = pageToTableMapFunc(pageName);    
    const hasBorderColor = changeBorderColor(listDeficiencyComment, pageToTableMap, labelName);

    let backgroundColor = "";
    if (disabledFlag) {
        backgroundColor = hasBorderColor ? BorderErrorColor : "#e0e0e0"; //disabledFlag === true 非活性
    } else {
        backgroundColor = hasBorderColor ? BorderErrorColor : "#1565c0"; //disabledFlag === false 活性
    }
    return {
        backgroundColor: backgroundColor,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "35px",
        height: "35px",
    };
};

// 吹き出しスタイル 寄付きページの側道A、側道B、裏道に値がありなしによって活性非活性になるもの
export const chatBubbleErrorAddBoolSx = (isSideWayBackstreet: boolean, userType: any, taskId: any, pageName: string, labelName: string, listDeficiencyComment:any) => {
    const disabledFlag = setPermissionAddBoolFunc(isSideWayBackstreet, userType, taskId, pageName, labelName);
    const hasBorderColor = changeBorderColor(listDeficiencyComment, pageName, labelName);
    let backgroundColor = "";
    if (disabledFlag) {
        backgroundColor = hasBorderColor ? BorderErrorColor : "#e0e0e0"; //disabledFlag === true 非活性
    } else {
        backgroundColor = hasBorderColor ? BorderErrorColor : "#1565c0"; //disabledFlag === false 活性
    }
    return {
        backgroundColor: backgroundColor,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "35px",
        height: "35px",
    };
};

// 吹き出しスタイル 通行量ページ 人通行量
export const chatBubbleErrorTrafficPeopleSx = (
    userType: any,
    taskId: any,
    pageName: string,
    labelName: string,
    listDeficiencyComment: any,
    objLocationTraffic5mcut: any,
) => {
    let backgroundColor = "";
    const disabledFlag = setPermissionFunc(userType, taskId, pageName, labelName);
    const hasBorderColor = changeBorderColor(listDeficiencyComment, pageName, labelName);

    const traffic5mcutFlag = (
        objLocationTraffic5mcut.approval_confirm_flag === "1" ||
        objLocationTraffic5mcut.approval_research_mgr_flag === "1" ||
        objLocationTraffic5mcut.approval_research_gm_flag === "1" ||
        objLocationTraffic5mcut.approval_mgr_flag === "1" ||
        objLocationTraffic5mcut.approval_gm_flag === "1"
    );

    if (traffic5mcutFlag) {
        backgroundColor = hasBorderColor ? BorderErrorColor : "#e0e0e0"; //非活性
    } else {
        if (disabledFlag) {
            backgroundColor = hasBorderColor ? BorderErrorColor : "#e0e0e0"; //disabledFlag === true 非活性
        } else {
            backgroundColor = hasBorderColor ? BorderErrorColor : "#1565c0"; //disabledFlag === false 活性
        }
    }

    return {
        backgroundColor: backgroundColor,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "35px",
        height: "35px",
    };
};

// 吹き出しスタイル 影響度ページ プルダウン
export const chatBubbleErrorImpactSx = (
    userType: any,
    taskId: any,
    pageName: string,
    labelName: string,
    listDeficiencyComment: any,
    subKeyStoreCode: string,
    subKeyTenpoName: string
) => {

    const disabledFlag = setPermissionFunc(userType, taskId, pageName, labelName);
    const pageToTableMap = pageToTableMapFunc(pageName);    
    const hasBorderColor = changeBorderImpactColor(listDeficiencyComment, pageToTableMap, labelName, subKeyStoreCode, subKeyTenpoName);

    let backgroundColor = "";
    if (disabledFlag) {
        backgroundColor = hasBorderColor ? BorderErrorColor : "#e0e0e0"; //disabledFlag === true 非活性
    } else {
        backgroundColor = hasBorderColor ? BorderErrorColor : "#1565c0"; //disabledFlag === false 活性
    }
    return {
        backgroundColor: backgroundColor,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "35px",
        height: "35px",
    };

};

// 吹き出しスタイル 影響度 交差点
export const chatBubbleErrorImpactIntersectionSx = (
    disabledFlag: boolean,
    selectStore: any,
    value: string,
    key: string,
    listDeficiencyComment: any
) => {
    // route
    let route = ""
    switch (selectStore.counter[value].impactCounter[key].impactData.seq) {
        case "0":
            route = `車${LOCAL_CONSTANT.LABEL.ROUTE}1`;
            break;
        case "1":
            route = `車${LOCAL_CONSTANT.LABEL.ROUTE}2`;
            break;
        case "2":
            route = `人${LOCAL_CONSTANT.LABEL.ROUTE}1`;
            break;
        case "3":
            route = `人${LOCAL_CONSTANT.LABEL.ROUTE}2`;
            break;
    }

    // intersection
    let impactNumberStr = "";
    let count = 0;
    Object.keys(selectStore.counter[value].impactCounter).map(uuid => {
        if (uuid === key) {
            impactNumberStr = LOCAL_CONSTANT.LABEL.FRONT_FOR_EXISTING_STORES
            if (count !== 0) {
                impactNumberStr = LOCAL_CONSTANT.LABEL.INTERSECTION + count
            }
        }
        count = count + 1
    })

    // subKeyをJSON形式に変更
    const subKey = JSON.stringify({
        routeSeq: selectStore.counter[value].impactCounter[key].impactData.seq,
        counterUuid: key,
        tenpoName: selectStore.data.tenpo_name,
        route: route,
        intersection: impactNumberStr,
    });

    const hasBorderColor = changeBorderImpactIntersectionColor(
        listDeficiencyComment,
        selectStore.data.tenpo_name + " " + impactNumberStr,
        subKey,
    );

    let backgroundColor = "";
    if (disabledFlag) {
        backgroundColor = hasBorderColor ? BorderErrorColor : "#e0e0e0"; //disabledFlag === true 非活性
    } else {
        backgroundColor = hasBorderColor ? BorderErrorColor : "#1565c0"; //disabledFlag === false 活性
    }

    return {
        backgroundColor: backgroundColor,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "35px",
        height: "35px",
    };
};


// 吹き出しアイコンのスタイル調整
export const chatBubbleIconSx = {
    color: "white",
};

//鉛筆スタイル調整
export const editIconCircleSx = {
    backgroundColor: "#e0e0e0",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "35px",
    height: "35px",
};

//アイコンホバー時のスタイル調整
export const iconHover = {
    padding: "4px 4px 4px 4px", //アイコンのpaddingを調整
    "&:hover": {
        backgroundColor: "transparent",
    },
};
